<template>
  <div id="popups">
    <!-- Content -->
    <CRow>
      <CCol sm="12">
        <CModal
          title="Remover"
          color="danger"
          :show.sync="removeModal.show"
          :centered="true"
        >
          Ao confirmar essa ação o item não poderá ser recuperado, tem certeza
          que desejar continuar?
          <template #footer>
            <button
              type="button"
              class="btn btn-secondary"
              @click="toggleModal"
            >
              Cancelar
            </button>
            <button type="button" class="btn btn-danger" @click="forceDelete">
              Remover
            </button>
          </template>
        </CModal>
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center py-3"
          >
            <h4 class="mb-0">
              Trabalhe Conosco
            </h4>
          </CCardHeader>
          <CCardBody>
            <!-- Search -->
            <CRow>
              <CCol col="12">
                <Search @search="updateSearch" />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="12">
                <CRow>
                  <!-- Area of interest -->
                  <CCol
                    md="4"
                    lg="4"
                    xl="3"
                  >
                    <div class="form-group">
                      <Multiselect
                        :value="
                          areaInterestOptions.find(
                            (option) => option.value == query.interest
                          )
                        "
                        :options="areaInterestOptions"
                        label="label"
                        track-by="value"
                        placeholder="Área de interesse"
                        @select="
                          (selected) => (query.interest = selected.value)
                        "
                      />
                    </div>
                  </CCol>

                  <!-- Education level -->
                  <CCol
                    md="4"
                    lg="4"
                    xl="3"
                  >
                    <div class="form-group">
                      <Multiselect
                        :value="
                          educationLevelOptions.find(
                            (option) => option.value == query.education_level
                          )
                        "
                        :options="educationLevelOptions"
                        label="label"
                        track-by="value"
                        placeholder="Nível de Escolaridade"
                        @select="
                          (selected) => (query.education_level = selected.value)
                        "
                      />
                    </div>
                  </CCol>

                  <!-- Training area -->
                  <CCol
                    md="4"
                    lg="4"
                    xl="3"
                  >
                    <div class="form-group">
                      <Multiselect
                        :value="
                          trainingAreaOptions.find(
                            (option) => option.value == query.training_level
                          )
                        "
                        :options="trainingAreaOptions"
                        label="label"
                        track-by="value"
                        placeholder="Área de formação"
                        @select="
                          (selected) => (query.training_level = selected.value)
                        "
                      />
                    </div>
                  </CCol>
                  <CCol
                    md="4"
                    lg="4"
                    xl="3"
                  >
                    <div class="form-group">
                      <div>
                        <label>Selecionar idade entre:</label>
                        <vue-slider
                          v-model="slider.value"
                          :min="slider.min"
                          :max="slider.max"
                          :interval="slider.interval"
                          :tooltip="slider.tooltip"
                          :tooltip-placement="'bottom'"
                          :tooltip-always-show="slider.tooltipAlwaysShow"
                          :height="slider.height"
                          @change="saveMinMax"
                        />
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <!-- Datatable -->
            <CRow>
              <CCol col="12">
                <DataTable
                  :sorter="query.sorter"
                  :items="datatable.items"
                  :fields="datatable.fields"
                  :enable-export="false"
                  base-route="/work-with-us/edit/"
                  @sorterValue="(event) => (query.sorter = event)"
                  @row-clicked="handleRowClick"
                  @selectedItem="(item) => handleSelectItem(item)"
                >
                  <template #actions="{ id }">
                    <DatatableEdit :url="`/work-with-us/edit/${id}`" />
                  </template>
                </DataTable>
              </CCol>
            </CRow>
            <CRow
              v-if="selectedItemsToDelete.length > 0"
              class="mt-2"
            >
              <CButton
                color="danger ml-4"
                @click="toggleModal"
              >
                Excluir Permanentemente
              </CButton>
            </CRow>

            <!-- Pagination -->
            <CRow class="mt-2">
              <CCol lg="12">
                <Pagination
                  :page="query.page"
                  :per-page="query.perpage"
                  :pages="pagination.pages"
                  :total="pagination.total"
                  :items="pagination.items"
                  @update:active-page="(page) => (query.page = page)"
                  @update:perpage="(perpage) => (query.perpage = perpage)"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
// Components
import DataTable from '@/components/ui/Datatable'
import DatatableEdit from '@/components/ui/DatatableActions/Edit'

import Pagination from '@/components/ui/Pagination'
import Search from '@/components/ui/Search'
import Multiselect from '@/components/ui/Multiselect'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

// Services
import Service from '@/services/work-with-us.service'

export default {
  metaInfo: {
    title: 'Trabalhe Conosco',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_work_with_us')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    DataTable,
    DatatableEdit,
    Pagination,
    Search,
    Multiselect,
    VueSlider
  },

  data() {
    return {
      datatable: {
        items: [],
        fields: [
          {
            key: 'selectAll',
            label: 'Selecionar',
            sorter: false
          },
          {
            key: 'name',
            label: 'Nome',
            _style: 'width: 20%;',
            sorter: true
          },
          {
            key: 'birthday',
            label: 'Idade',
            sorter: true
          },
          {
            key: 'interest_name',
            label: 'Área de interesse',
            sorter: true
          },
          {
            key: 'education_level_name',
            label: 'Nível de Escolaridade',
            sorter: true
          },
          {
            key: 'training_level_name',
            label: 'Área de formação',
            sorter: true
          },
          {
            key: 'actions',
            label: 'Ações',
            sorter: false,
            _style: 'width: 12%; min-width: 0px'
          }
        ]
      },
      slider: {
        value: [0, 100],
        min: 0,
        max: 100,
        interval: 1,
        tooltip: 'hover',
        tooltipAlwaysShow: true,
        height: 2
      },
      selectedItemsToDelete: [],
      query: {
        search: '',
        page: 1,
        ageMin: 0,
        ageMax: 100,
        perpage: localStorage.getItem('perPageItem')
          ? parseFloat(localStorage.getItem('perPageItem'))
          : 10,
        pagination: true,
        interest: null,
        education_level: null,
        training_level: null,
        sorter: {
          asc: false,
          column: ''
        }
      },
      pagination: {
        total: 0,
        pages: 0,
        items: 0
      },
      areaInterestOptions: [
        {
          label: 'Todas as áreas de interesse',
          value: null
        }
      ],
      educationLevelOptions: [
        {
          label: 'Todos os níveis de escolaridade',
          value: null
        }
      ],
      trainingAreaOptions: [
        {
          label: 'Todas as áreas de formação',
          value: null
        }
      ],
      rowCliked: {},
      removeModal: {
        show: false,
        title: '',
        message: '',
        color: ''
      }
    }
  },

  watch: {
    query: {
      handler: 'updateDataTable',
      deep: true
    }
  },

  async created() {
    await this.getFilterOptions()
    await this.updateDataTable()
  },

  methods: {
    saveMinMax(values) {
      this.query.ageMin = values[0]
      this.query.ageMax = values[1]
    },
    toggleModal() {
      this.removeModal.show = !this.removeModal.show
    },
    removeData() {

    },
    async forceDelete() {
      this.toggleModal()
      for (let i = 0; i < this.selectedItemsToDelete.length; i++) {
        await Service.forceDelete(this.selectedItemsToDelete[i])
      }
      this.selectedItemsToDelete = []
      this.updateDataTable()
    },
    async updateDataTable() {
      const response = await Service.index(this.query)
      const { data, pagination } = response

      if (data) {
        this.pagination = {
          ...pagination,
          pages: pagination.lastPage,
          items: data.length
        }

        const newItems = response.data.map((item) => {
          return {
            ...item,
            area_of_interest: item.interest ? item.interest.name : null,
            education_level: item.education_level
              ? item.education_level.name
              : null,
            training_area: item.training_level ? item.training_level.name : null
          }
        })

        this.datatable.items = newItems
      }
    },

    handleSelectItem(item) {
      if (this.selectedItemsToDelete.includes(item)) {
        this.selectedItemsToDelete.pop(item)
      } else {
        this.selectedItemsToDelete.push(item)
      }
    },

    async getFilterOptions() {
      const response = await Service.getFilterOptions()

      const interestOptions = response.data.interestsOptions.map((item) => {
        return {
          label: item.name,
          value: item.id
        }
      })
      const educationLevelOptions = response.data.educationLevelOptions.map(
        (item) => {
          return {
            label: item.name,
            value: item.id
          }
        }
      )

      const trainingAreaOptions = response.data.trainingLevelOptions.map(
        (item) => {
          return {
            label: item.name,
            value: item.id
          }
        }
      )

      this.areaInterestOptions = [
        ...this.areaInterestOptions,
        ...interestOptions
      ]
      this.educationLevelOptions = [
        ...this.educationLevelOptions,
        ...educationLevelOptions
      ]
      this.trainingAreaOptions = [
        ...this.trainingAreaOptions,
        ...trainingAreaOptions
      ]
    },

    async updateSearch(searchText) {
      this.query.search = searchText
      this.query.page = 1

      await this.updateDataTable()
    },

    handleRowClick(event) {
      this.rowCliked = event
    }
  }
}
</script>

<style lang="scss"></style>
